import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

import {
    AppLayout, HelpPanel, Icon, BreadcrumbGroup, Box, Table, SpaceBetween, Header, Button,
    Container, Spinner, Pagination, Alert, Modal, Link,
    KeyValuePairs,
    CopyToClipboard,
    ExpandableSection
} from '@amzn/awsui-components-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useAuth } from "../../context/AuthContextProvider";
import { Storage } from 'aws-amplify';
import { configureDynamicS3 } from 'src/context/AuthContextUtility'
import { S3_CONFIG } from 'src/constants/AppConstants';
import { cleanS3PathForDownload } from 'src/utilities/S3Utils';
import EmbedResults from 'src/generic-components/EmbedResults/EmbedResults';
import { getDocumentFromVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from "src/Ateam-BI/Vault/constants";


const FriscoTransactionFileListViewer = (props) => {

    const userAuthenticationDetails = useAuth();
    const history = useHistory();
    const dispatch = useDispatch()
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const [error, setError] = useState(false);
  const [showDownloadAndView, setShowDownloadAndView] = useState(true)
    const userId = useSelector((globalState) => globalState.auth.userId);

    const downloadFile = async (path, bucket) => {
        if (bucket) {
          let region = S3_CONFIG.find((c) => c.environment === currentStage)?.region
          configureDynamicS3(bucket, region)
        }
        if (path) {
          let paths = path?.split(',')
          if (paths?.length > 0) {
            for (let i = 0; i < paths.length; i++) {
              let fn = paths[i]
              let prefix = 'public/'
              let arr = fn.split('.')
              let contentType = arr[arr.length - 1]
              let service;
              if (bucket && bucket?.toUpperCase().includes("FRISCO")) {
                // fn = fn.replace('frisco/', '')
                service = VAULT_SERVICES.FRISCO
                prefix = 'frisco/'
              } else if (bucket && bucket?.toUpperCase().includes("FLEXICO")) {
                // fn = fn.replace('flexico/', '')
                service = VAULT_SERVICES.FLEXICO
                prefix = 'flexico/'
              } else {
                fn = fn.replace('public/', '')
              }
              fn = cleanS3PathForDownload(fn)
              // const result = await Storage.get(decodeURIComponent(fn).replaceAll('ABCPLUSTEMP', '+'), { level: 'public', customPrefix: { public: prefix }, expires: 60 });
              let document = await getDocumentFromVault(contentType, service, {"file_path": `${decodeURIComponent(fn).replaceAll('ABCPLUSTEMP', '+')}`, "service_id":`${props?.transactionDetails?.processId}`, "app_id":`${props?.transactionDetails?.appId}`})                
              let fileURL = document?.fileUrl
              window.open(fileURL);
            }
          }
        }
        else {
          window.open("");
        }
    
      }

      const downloadSupportingDocuments = async (item, index) => {
          let files = item.supportingDocuments
          configureDynamicS3(item.bucket_name, item.region || 'us-east-1')
            let filefn = files[index]
            let arr = filefn.split('.')
            let contentType = arr[arr.length - 1]
            // sometimes FRISCO saved the supporting docs to the actual folder dedicated to fileID, but there is an issue where the uris saved are stage path whoch will not exist. Hence, backwards compatibility for files uploaded previously(before the fix)
            if (filefn?.includes('stage/')) {
              filefn = filefn.replace('stage/', 'source/')
            }
            let prefix = 'frisco/'
            // const result = await Storage.get(decodeURIComponent(cleanS3PathForDownload(filefn)).replaceAll('ABCPLUSTEMP', '+'), { level: 'public', customPrefix: { public: prefix }, expires: 60 });
            let document = await getDocumentFromVault(contentType, VAULT_SERVICES.FRISCO, {"file_path": `${decodeURIComponent(cleanS3PathForDownload(filefn)).replaceAll('ABCPLUSTEMP', '+')}`, "service_id":`${props?.transactionDetails?.processId}`, "app_id":`${props?.transactionDetails?.appId}`})                
            let fileURL = document?.fileUrl
            window.open(fileURL);
          
        }

    const fileDetails = (
        <>
            {
                props?.transactionDetails && <Box>
                  <SpaceBetween direction="horizontal" size="m">
                    {
                      props?.transactionDetails.rawFilePath && props?.transactionDetails.bucket_name &&
                      <Button
                        variant={!props?.liteView ? "primary" : "inline-link"}
                        iconName="download"
                        onClick={() => downloadFile(props?.transactionDetails.rawFilePath, props?.transactionDetails.bucket_name)}
                        disabled={!showDownloadAndView}
                      >  Raw file</Button>
                    }
                    {
                      props?.transactionDetails.filePath && props?.transactionDetails.bucket_name &&
                      <Button 
                        variant={!props?.liteView ? "primary" : "inline-link"}
                        iconName="download"
                        onClick={() => downloadFile(props?.transactionDetails.filePath, props?.transactionDetails.bucket_name)}
                        disabled={!showDownloadAndView}
                      >
                        Download
                      </Button>
                    }
                    {
                      props?.transactionDetails.supportingDocuments && props?.transactionDetails.bucket_name && 
                      <ExpandableSection headerText={<Box variant={!props?.liteView ? 'h4' : 'p'}>supporting docs</Box>}>
                          <SpaceBetween direction="vertical">
                            {props?.transactionDetails.supportingDocuments.map((document, index) => {
                              // Extract filename from the path
                              const fileName = document?.split('/').pop();
        
                              return (
                                <Button
                                  key={index}
                                  iconName="download"
                                  variant="inline-link"
                                  onClick={() => downloadSupportingDocuments(props?.transactionDetails, index)}
                                  disabled={!showDownloadAndView}>
                                  {fileName}
                                </Button>
                              );
                            })}
                          </SpaceBetween>
                          
                      </ExpandableSection>
                      
                    }
                  </SpaceBetween>
                  {
                      (props?.transactionDetails.filePath || props?.transactionDetails.rawFilePath || (props?.transactionDetails.supportingDocuments?.length > 0)) && props?.transactionDetails.bucket_name &&
                      !props?.liteView && (() => {
                        // Build s3Reports array with filePath, rawFilePath, and supportingDocuments
                        const reports = [];
                        if (props.transactionDetails.filePath) {
                          const fileName = props.transactionDetails.filePath.split('/').pop() || 'Data';
                          reports.push({ label: fileName, uri: props.transactionDetails.filePath, bucket: props.transactionDetails.bucket_name });
                        }
                        if (props.transactionDetails.rawFilePath) {
                          const fileName = props.transactionDetails.rawFilePath.split('/').pop() || 'Original';
                          reports.push({ label: fileName, uri: props.transactionDetails.rawFilePath, bucket: props.transactionDetails.bucket_name });
                        }
                        if (props.transactionDetails.supportingDocuments && Array.isArray(props.transactionDetails.supportingDocuments)) {
                          props.transactionDetails.supportingDocuments.forEach(doc => {
                            const fileName = doc?.split('/').pop() || 'Supporting Doc';
                            reports.push({ label: fileName, uri: doc, bucket: props.transactionDetails.bucket_name });
                          });
                        }
                        return <EmbedResults s3Reports={reports} showAllAsTab={false} serviceId={props?.transactionDetails?.processId} appId={props?.transactionDetails?.appId}></EmbedResults>;
                      })()
                    }
                </Box> 
            }
            </>
    )

    return(
        <Box textAlign="center">
            {
                error ?
                    <Box variant="h1" color="text-status-error">Invalid id</Box> :
                    <Box> {fileDetails}</Box>
            }
        </Box>
    )
}



export default FriscoTransactionFileListViewer

